<template>
  <div class="game-tr-select-game-with-text-impr">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      :class="{ 'main-big-photo': startGameConfig.bigPhoto }"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setMainImageValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setMainImageValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setMainImageValue(startGameConfig.mainImage.pos.y, 0) + 'px',
        left: setMainImageValue(startGameConfig.mainImage.pos.x, 0) + 'px',
      }"
    />
    <!-- <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div> -->
    <tr-static-text
      :static-text="item"
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
    >
    </tr-static-text>
    <tr-box
      v-if="words.length"
      :items="words"
      :config="boxConfig"
      :font-size="boxConfigFontSize"
      :style="getBoxStyle(startGameConfig.boxConfig)"
      class="box-style"
    ></tr-box>
    <div class="text-container" :style="getTextStyle(elem)" v-for="(elem, index) in textItem" :key="index">
      <!-- <mb-audio
        v-if="elem.audioSrc"
        :item-audio="{ audioSrc: elem.audioSrc, position: 'relative', audioCss: elem.audioCss }"
      ></mb-audio> -->
      <component :is="dynComponent(index)" v-bind="$props"></component>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
// import Vue from 'vue';
import * as utils from '../../Utils/inputUtils';
import TrSelect from '../TrSelect/TrSelect';
import TrStaticText from '../TrInput/TrStaticText';
import TrBox from '../../GameBaseElements/TrBox/TrBox';
import defaultMixin from '../../mixins/defaultMixin';
import inputMixin from '../../mixins/inputMixin';
import MbAudio from '__mainSrcDir/components/MbAudio/MbAudio';
import LmSelect from '../TrInput/LmSelect';
import TrText from '../TrInput/TrText';
/**
 * @namespace SelectGameWithTextImpr
 */

/**
 * Pojedyńcza odpowiedź w select
 * @typedef {Object} SelectOption
 * @property {String} text - tekst odpowiedzi
 * @property {Boolean} correct - czy poprawna odpowiedź
 * @example
 *
 * (...)
 *   {
 *    text: 'C_{15}H_{31}COOH',
 *    correct: true,
 *   },
 * (...)
 */

/**
 * Konfigurownanie selectów
 * @typedef {Object} SelectMarker
 * @memberof SelectGameWithTextImpr
 *
 * @property {Boolean} shuffle - czy tablica **options** ma się losować
 * @property {Number} katexFontSize - Rozmiar czcionki katexa w selectach
 * @property {Array.<SelectOption>} options - tablica z możliwymi odpowiedziami
 * @property {Boolean} configDeep -jeśli __true__ konfiguracja  wewnętrzna jest brana pod uwagę. Gdy flaga jest ustawiona na __true__ oraz istnieją cssStyle lub inputWidth, itd... wewnątrz obiektu to wartości z głównej konfiguracji są merg-owane z tymi z markers (dokładnie _lodash-owa_ metoda _defaultsDeep_ gdzie startowe dane to dane z głownej konfiguracji)
 * @property {Number} inputWidth - szerokość selecta
 * @property {Object} cssStyle - indywidualny styl CSS, którym można zmienić wygląd elementu poza szerokością (ta ustawiana jest za pomocą __inputhWidth__ ).
 *
 * @example
 *
 * (...)
 *   {
 *    shuffle: true,
 *    inputWidth: 200,
 *    options: [
 *      {
 *        text: 'C_{16}H_{33}COOH',
 *        configDeep: true,
 *          cssStyle:{
 *            color:'red'
 *          },
 *      },
 *      {
 *        text: 'C_{15}H_{31}COOH',
 *        correct: true,
 *      },
 *      {
 *        text: 'C_{17}H_{35}COOH',
 *      },
 *    ],
 *  },
 *
 * (...)
 *
 */

/**
 * Bloki tekstu z selectami oznaczonymi markerami **__elem0__,__elem1__**,itd. jesli jest wiecej niz 1 to opcje dla markerow ustawiane sa w tablicy markers w kolejnosci
 * @typedef {Object}  SelectConfig
 * @memberof SelectGameWithTextImpr
 *
 * @property {String}  text - tekst z miejscami na selecty oznaczonymi markerami __elem0__,__elem1__,itd. jesli jest wiecej niz 1 to opcje dla markerow ustawiane sa w tablicy markers w kolejnosci. W przypadku konieczności użycia KATEX-a należy dać do markera {katex:true}
 * @property {Array.<SelectGameWithTextImpr.SelectMarker>}  markers - tablica konfiguracji selectu
 *
 * @example
 *
 * (...)
 *
 * {
 *    text:
 *      '1. kwas palmitynowy fgd_#PbSO_4#_ <br />a) __elem0{katex:true}__ + fgd_#PbSO_4#_ + __elem1__ fgd_#PbSO_4#_',
 *    markers: [
 *      {
 *        shuffle: true,
 *        inputWidth: 200,
 *        options: [
 *          {
 *            text: 'C_{16}H_{33}COOH',
 *          },
 *          {
 *            text: 'C_{15}H_{31}COOH',
 *            correct: true,
 *          },
 *          {
 *            text: 'C_{17}H_{35}COOH',
 *          },
 *        ],
 *      },
 *      {
 *        shuffle: true,
 *        inputWidth: 200,
 *        options: [
 *          {
 *            text: '7',
 *          },
 *          {
 *            text: '13',
 *          },
 *          {
 *            text: '15',
 *            correct: true,
 *          },
 *        configDeep: true,
 *        cssStyle:{
 *           color:'red'
 *        },
          inputWidth: 500,
 *        ],
 *      },
 *    ],
 *  },
 *
 * (...)
 */

/**
 * @typedef SelectGameWithTextImprConfig
 *
 * @property {MainImage}  mainImage - konfogurowalne tło
 * @property {Array<Pos>} layoutItems - tablica położeń dla inputów
 * @property {Array.<Pos>} layoutImages- tablica położeń dla obrazków
 * @property {Boolean} caseSensitive - czy inputy mają być wrażliwe na wielkośc znaków
 * @property {Number}  inputWidth  - domyślna szerokość [px]
 * @property {Number}  blockWidth  - domyślna wysokość całego bloku [px]
 * @property {Number}  blockHeight - domyślna wysokość całego tekstu [px]
 * @property {Number}  textBlockWidth - domyślna szerokość całego bloku tekstu [px]
 * @property {Number}  textBlockHeight - domyślna wysokość całego bloku tekstu [px]
 * @property {String}  blockBackgroundColor - domyślny kolor tła
 * @property {Number}  gameFontSize - domyslna wielkość czcionki
 *
 * @property {Number}  inputFontSize - defaultowa wielkość czcionki inputów
 * @property {Number}  inputMaxLength - defaultowa maksymalna ilość znaków możliwyh do wprowadzenia
 * @property {Boolean}  shuffle - czy tablica **items** ma się losować
 * @property {Number}  pick  - ilość elementów do wybrania
 * @property {Array.<SelectGameWithTextImpr.SelectConfig>} items - tablica elementów
 */
/**
 * @name SelectGameWithTextImpr-config
 * @memberof SelectGameWithTextImpr
 * @type SelectGameWithTextImprConfig
 *
 */
var config;
export default {
  name: 'tr-select-game-with-text-impr',
  components: { TrSelect, TrBox, TrStaticText, MbAudio, LmSelect, TrText },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin, inputMixin],
  data() {
    return {
      imageData: {},
      textItem: [],
      words: [],
      staticText: [],
      katexfontSize: this.startGameConfig.katexFontSize,

      boxConfig: {
        x: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.left) || 1,
        y: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.top) || 14,
        width: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.width) || 98,
        height: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.height) || 12,
        unit: '%',
        wordConfig: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.wordConfig) || {},
      },
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  methods: {
    setMainImageValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
    /**
     * parsing function. Replace markes (__elem0__,__elem1__, etc.) to component and passing all data
     * @method parseText
     * @param  {String}  text base text with markers
     * @return {String}       reparsed text with correct components
     */
    parseText(text) {
      let pText = [];
      pText.push(`<div><div class="text-with-input""><mb-audio
        v-if="baseItems[${0}].audioSrc"
        :item-audio="{ audioSrc: baseItems[${0}].audioSrc, position: 'absolute', audioCss: baseItems[${0}].audioCss }"
      ></mb-audio></div>`);
      text = _.split(text, /__(.*?)__/g);
      let katexStatus = 'katex:true';
      let elem_iterator = 0;

      _.each(text, (item, index) => {
        if (index === 0) {
          pText.push(`<div class="text-with-input"
          :style="getStyle(baseItems[${index}])">`);
        }

        //console.log(text[index].includes(katexStatus));
        if (index <= text.length - 2 && text[index].includes(katexStatus) == true && index % 2 === 1) {
          let LmText = `<lm-select
            :katexsize="katexfontSize"
             :config="baseItems[${elem_iterator}]"
            :inputWidth="inputWidth(baseItems[${elem_iterator}])"
            :inputHeight="inputHeight(baseItems[${elem_iterator}])"
            :tr-select-value="selected[${elem_iterator}]"
            :options="baseItems[${elem_iterator}].options"
            @change="setNewLmValue($event,${elem_iterator})"
                        @click.native="resetCheckStatus"
              class="select"
          ></lm-select>`;

          pText.push(LmText);
          elem_iterator++;
        } else if (index <= text.length - 2 && index % 2 === 1) {
          let newText = `<tr-select
            :listFontSize="listFontSize"
            :config="baseItems[${elem_iterator}]"
            :inputWidth="inputWidth(baseItems[${elem_iterator}])"
            :inputHeight="inputHeight(baseItems[${elem_iterator}])"
            :options="baseItems[${elem_iterator}].options"
            :tr-select-value="selected[${elem_iterator}]"
            @change="setNewValue($event,${elem_iterator})"
            @click.native="resetCheckStatus"
            class=" select-style"
          ></tr-select>`;

          pText.push(newText);
          elem_iterator++;
        } else {
          pText.push(`<span  class="text-block-inner-text" :style="getInnerTextStyle(baseItems[0])">`);
          if (this.hasKatex(item)) {
            let parsed = this.parseKatex(item);
            for (const elem of parsed) {
              let text = elem.value || ' ';
              pText.push(`<tr-text :text="'${text}'" :type="${elem.katex}"> </tr-text>`);
            }
          } else {
            pText.push(item);
          }
          pText.push('</span>');
        }
      });
      pText.push('</div></div>');
      return pText.join('');
    },
    init() {
      this.textItem = this.prepareData();
      this.baseItems = this.textItem;

      let markersArray = [];
      _.each(this.textItem, (item) => {
        if (item.markers) {
          _.each(item.markers, (marker) => {
            if (marker.shuffle) {
              marker.options = _.shuffle(_.cloneDeep(marker.options));
            }
            markersArray.push(marker);
          });
        } else {
          markersArray.push(item);
        }
      });
      this.selected = _.map(markersArray, (item) => {
        return {
          correct: item.correct,
          val: item.value || '',
          block: item.block || false,
          inputStatus: item.inputStatus || null,
        };
      });
      this.baseItems = this.textItem = _.map(this.textItem, (item) => {
        item.text = this.parseText(item.text);
        return item;
      });
    },
    prepareData() {
      let data = _.cloneDeep(this.startGameConfig.items);
      // let staticText = [];
      console.log(this.startGameConfig.mainImage);
      let dataOptions = { pick: null, shuffle: null };
      if (
        this.startGameConfig.pick &&
        this.startGameConfig.items[0] &&
        this.startGameConfig.items[0].items &&
        this.startGameConfig.items[0].items.length > 0
      ) {
        data = _.take(_.cloneDeep(data), this.startGameConfig.pick);
        if (this.startGameConfig.pick > 1) {
          data = _.reduce(
            data,
            (result, value, key) => {
              dataOptions = _.merge({}, dataOptions, {
                pick: value.pick,
                shuffle: value.shuffle,
              });
              if (value.pick && value.items) {
                value.items = _.take(value.items, value.pick);
              }
              if (value.shuffle && value.items) {
                value.items = _.shuffle(value.items);
              }
              if (value.staticText) {
                this.staticText.push(value.staticText);
              }
              if (value.items) {
                _.each(value.items, (singleElem) => {
                  result.push(singleElem);
                });
              }
              return result;
            },
            []
          );
        } else {
          dataOptions = { pick: data[0].pick, shuffle: data[0].shuffle };
          if (data[0].imageData) {
            this.imageData = data[0].imageData;
          } else if (this.startGameConfig.mainImage) {
            this.imageData = this.startGameConfig.mainImage;
          } else if (this.startGameConfig.background) {
            this.imageData = Object.assign({}, { imagePath: this.startGameConfig.background });
          }
          data = _.clone(data[0].items);
        }
      } else {
        dataOptions = {
          pick: this.startGameConfig.pick,
          shuffle: this.startGameConfig.shuffle,
        };

        if (data.imageData) {
          this.imageData = data.imageData;
        } else if (this.startGameConfig.mainImage) {
          this.imageData = this.startGameConfig.mainImage;
        } else if (this.startGameConfig.background) {
          this.imageData = Object.assign({}, { imagePath: this.startGameConfig.background });
        }
        data = _.cloneDeep(data);
      }

      let sData = {};
      let staticData = _.filter(data, (item) => {
        return !_.isNil(item.staticIndex);
      });
      if (staticData.length > 0) {
        staticData = _.sortBy(_.cloneDeep(staticData), ['staticIndex']);
        data = _.map(data, (item) => {
          if (_.isNil(item.staticIndex)) {
            return item;
          }
        });
      }
      data = _.compact(data);
      if (dataOptions.shuffle) {
        data = _.shuffle(data);
      }
      if (dataOptions.pick) {
        sData = _.take(_.cloneDeep(data), dataOptions.pick - staticData.length);
      } else {
        sData = _.cloneDeep(data);
      }
      _.each(staticData, (item) => {
        sData.splice(item.staticIndex, 0, item);
      });
      data = sData;
      if (this.startGameConfig.staticText) {
        this.staticText = this.staticText.length === 0 ? this.startGameConfig.staticText : this.staticText;
      }
      if (this.staticText.length > 0) {
        this.staticText = _.map(this.staticText, (item, index) => {
          if (this.startGameConfig.layoutStaticText) {
            return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
          } else {
            return item;
          }
        });
      }
      /**
       * set all data together.
       * this.startGameConfig.layoutItems is REQUIERED
       */
      this.textItem = _.map(data, (item, index) => {
        if (this.startGameConfig.layoutItems && this.startGameConfig.layoutItems[index]) {
          return _.defaultsDeep(_.cloneDeep(item), _.cloneDeep(this.startGameConfig.layoutItems[index]));
        }
        return _.cloneDeep(item);
      });
      /**
       * box text aplly
       */
      if (this.startGameConfig.words) {
        let syncData = this.startGameConfig.boxConfig.syncData;
        this.words = this.startGameConfig.words;
        if (this.startGameConfig.boxConfig && syncData) {
          this.words = _.intersection(
            this.startGameConfig.words,
            _.flattenDeep(
              _.map(this.textItem, (item) => {
                if (item[syncData]) {
                  return [...item[syncData]];
                } else if (item.markers) {
                  return _.flattenDeep(
                    _.map(item.markers, (item) => {
                      return [...item[syncData]];
                    })
                  );
                }
                return [...item[syncData]];
              })
            )
          );
        }
        this.words = _.shuffle(this.words);
      }
      return _.cloneDeep(this.textItem);
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge(
        {
          'background-size': 'contain',
          'background-repeat': 'no-repeat',
          'background-position': 'center,center',
          position: 'relative',
          display: 'block',
          'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        },
        this.getCustomStyle(imageData),
        {
          top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
          left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
          width: utils.elementWidth(imageData.width),
          height: utils.elementHeight(imageData.height),
        }
      );
    },

    setGameStyle() {
      return {
        'flex-direction': this.startGameConfig.flexDirection || 'row',
      };
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getTextStyle(element) {
      return _.merge({ position: 'absolute' }, this.getCustomStyle(element), {
        top: utils.elementTopPosition(element.pos.y, element.offsetVertical),
        left: utils.elementLeftPosition(element.pos.x, element.offsetHorizontal),
        width: element.blockWidth
          ? utils.elementWidth(element.blockWidth)
          : utils.elementWidth(this.startGameConfig.blockWidth),
        height: element.blockHeight
          ? utils.elementHeight(element.blockHeight)
          : utils.elementHeight(this.startGameConfig.blockHeight),
        'background-color': element.blockBackgroundColor || this.startGameConfig.blockBackgroundColor,
        'font-size': this.startGameConfig.gameFontSize + 'px',
      });
    },

    getBoxStyle(box) {
      box.x = box.x;
      box.y = box.y;
      box.width = box.width;
      box.height = box.height;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(box), {
        left: utils.elementLeftPosition(box.x, 0, '%'),
        top: utils.elementTopPosition(box.y, 0, '%'),
        width: utils.elementWidth(box.width, '%'),
        height: utils.elementHeight(box.height, '%'),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      this.init();
    },
    checkGameAction() {
      let status = _.reduce(
        this.selected,
        (result, value, key) => {
          let temVal = null;
          if (value.correct) {
            temVal = result && true;
            value.block = true;
            value.inputStatus = 'correct';
          } else {
            temVal = false;
            value.block = true;
            value.inputStatus = 'incorrect';
            setTimeout(() => {
              value.val = '';
              value.block = false;
              value.inputStatus = null;
            }, 1000);
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.selected, (item, key) => {
          console.log('item', item);
        });
      }
      return status;
    },
    getCorrectIndex(selected, textItem, index) {
      let arrayIndex = 0;
      for (var i = 0; i < index; i++) {
        if (textItem[i] && textItem[i].markers) {
          _.each(textItem[i].markers, (item) => {
            arrayIndex++;
          });
        } else {
          arrayIndex++;
        }
      }
      return arrayIndex;
    },
    getCorrectInput(index) {
      let array = [];
      let correctIndex = this.getCorrectIndex(this.selected, this.textItem, index);
      if (this.textItem[index].markers) {
        _.each(this.textItem[index].markers, (item, index) => {
          array.push(this.selected[correctIndex + index]);
        });
      } else {
        array.push(this.selected[correctIndex]);
      }
      return array;
    },
    getCorrectBaseItems(index) {
      let markersArray = [];
      if (this.textItem[index] && this.textItem[index].markers) {
        markersArray = _.map(this.textItem[index].markers, (marker) => {
          if (marker.configDeep) {
            return _.defaultsDeep(marker, _.omit(this.textItem[index], ['markers', 'pos', 'shuffle']));
          } else {
            return _.extend(marker, _.omit(this.textItem[index], ['markers', 'pos', 'shuffle']));
          }
        });
      } else {
        markersArray.push(_.omit(this.textItem[index], ['pos']));
      }
      return markersArray;
    },
    hasKatex(string) {
      return string.match(/(_#.*?#_)/g);
    },
    /** Function added only for compatibility with hack in textBlock type components */
    removeUnnecessarySlash(string) {
      const search = '\\\\\\\\';
      const replaceWith = '\\\\';
      const result = string.split(search).join(replaceWith);
      return result;
    },
    parseKatex(string) {
      let parsed = [];
      let split = string.split(/(_#.*?#_)/g);
      if (split) {
        parsed = split.map((item) => {
          let katexFlag = false;
          let match = item.match(/_#(.*?)#_/g);
          if (match) {
            katexFlag = true;
            item = item.substring(2, item.length - 2);
            item = this.removeUnnecessarySlash(item);
          }
          return { katex: katexFlag, value: item };
        });
      }
      return parsed;
    },
    dynComponent(index) {
      let correctInput = this.getCorrectInput(index);
      let correctIndex = this.getCorrectIndex(this.selected, this.textItem, index);
      let markersLength = this.textItem[index].markers ? this.textItem[index].markers.length : 1;
      const template = this.content ? this.content : this.textItem[index].text;
      let data = {
        mainImage: _.cloneDeep(this.startGameConfig.mainImage),
        text: _.cloneDeep(this.textItem[index].text),
        selected: correctInput,
        baseItems: _.cloneDeep(this.getCorrectBaseItems(index)),
        katexfontSize: this.startGameConfig.katexFontSize,
        listFontSize: this.startGameConfig.listFontSize,
      };
      return {
        template,
        mixins: [defaultMixin],
        components: { TrSelect, LmSelect, TrText, TrStaticText, MbAudio },
        data() {
          console.log('DATA', data);
          return data;
        },
        methods: {
          selectConfig(item) {
            return _.omit(item, ['pos', 'width', 'height']);
          },
          getStyle(item) {
            return _.merge({}, this.getCustomStyle(item), {
              width: item.textBlockWidth
                ? utils.elementWidth(item.textBlockWidth)
                : utils.elementWidth(this.startGameConfig.textBlockWidth),
              height: item.textBlockHeight
                ? utils.elementHeight(item.textBlockHeight)
                : utils.elementHeight(this.startGameConfig.textBlockHeight),
            });
          },
          getInnerTextStyle(item) {
            return _.assign({}, this.getCustomInnerTextStyle(item));
          },
          getCustomInnerTextStyle(item) {
            let customStyle = {};
            if (item.cssInnerTextStyle) {
              if (_.isObject(item.cssInnerTextStyle)) {
                customStyle = _.mapKeys(item.cssInnerTextStyle, function (value, key) {
                  return _.toString(key);
                });
              }
            }
            return customStyle;
            // return {
            //   'width': (item.textBlockWidth) ? utils.elementWidth(item.textBlockWidth) : utils.elementWidth(this.startGameConfig.textBlockWidth),
            //   'height': (item.textBlockHeight) ? utils.elementHeight(item.textBlockHeight) : utils.elementHeight(this.startGameConfig.textBlockHeight),
            //   'justify-content': (item.flexJustify) ? 'center' : item.flexJustify,
            // };
          },
          getCustomStyle(item) {
            let customStyle = {};
            if (item.cssStyle) {
              if (_.isObject(item.cssStyle)) {
                customStyle = _.mapKeys(item.cssStyle, function (value, key) {
                  return _.toString(key);
                });
              }
            }
            return customStyle;
          },
          inputWidth(item) {
            if (item.inputWidth) {
              return item.inputWidth;
            } else if (this.startGameConfig.inputWidth) {
              return this.startGameConfig.inputWidth;
            }
            return false;
          },
          inputHeight(item) {
            if (item.inputHeight) {
              return item.inputHeight;
            } else if (this.startGameConfig.inputHeight) {
              return this.startGameConfig.inputHeight;
            }
            return false;
          },
          setNewValue(value, index) {
            console.log('value', value);
            let trValue = _.defaults({}, value, {
              correct: undefined,
              val: '',
              block: false,
              inputStatus: null,
            });
            trValue.val = value.text;
            _.assign(this.selected[index], trValue, { val: value });
          },
          setNewLmValue(value, index) {
            console.log('value', value);
            let trValue = _.defaults({}, value, {
              correct: undefined,
              val: '',
              block: false,
              inputStatus: null,
            });
            trValue.val = value.text;
            _.assign(this.selected[index], trValue, { val: value.val });
          },
        },
        props: this.$props,
      };
    },
  },
  computed: {
    boxConfigFontSize() {
      let fontSize = this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.fontSize;
      return fontSize + 'px';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$elementWidth: 1478px;
$elementHeight: 153px;
$fontSize: 35px;
%item {
  transition: all 0.5s;
  text-align: center;
  font-size: $fontSize;
  font-family: $gameFontFamily;
  font-style: normal;
  font-variant: normal;
  font-weight: 500;
}
.game-tr-text-block-with-input-impr {
  height: 100%;
  width: 93%;
  margin-left: 1%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .text-container {
    text-align: justify;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.text-with-input {
  display: flex;
  width: 250px;
  justify-content: space-between;
  align-items: baseline;
  flex-direction: row;
}
.text-block-inner-text {
  margin-right: 1em;
  margin-left: 1em;
}
.marker-style {
  width: 100px;
  height: 40px;
  display: inline-block;
}
</style>
<style lang="scss">
.game-tr-select-game-with-text-impr {
  .text-container {
    .text-with-input {
      .text-block-inner-text {
        margin-right: 1rem;
        margin-left: 1rem;
      }
    }
  }
  .main-img {
    position: fixed;
    object-fit: cover;
  }
  .main-big-photo {
    position: relative;
    object-fit: cover;
  }
}
</style>
